(function () {
  var STORAGE_KEY_BASE = 'bf_wishlist';
  var NOT_IN_WISHLIST_TEXT = 'Not In Wishlist';
  var IN_WISHLIST_TEXT = 'Added In Your Wishlist';

  function storageKey() {
    var customerId = document.body ? document.body.getAttribute('data-customer-id') : '';
    return customerId ? STORAGE_KEY_BASE + '_customer_' + customerId : STORAGE_KEY_BASE;
  }

  function getWishlist() {
    try {
      var raw = localStorage.getItem(storageKey());
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(storageKey(), JSON.stringify(handles));
    } catch (e) {}
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function setButtonState(btn, active) {
    if (!btn) return;
    if (active) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
    var textEl = btn.querySelector ? btn.querySelector('.wishlist_text') : null;
    if (textEl) {
      textEl.textContent = active ? IN_WISHLIST_TEXT : NOT_IN_WISHLIST_TEXT;
    }
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
    });
  }

  window.toggleWishlist = function (handle, el) {
    if (!handle) return;
    var handles = getWishlist();
    var idx = handles.indexOf(handle);
    var nowActive;
    if (idx === -1) {
      handles.push(handle);
      nowActive = true;
    } else {
      handles.splice(idx, 1);
      nowActive = false;
    }
    saveWishlist(handles);

    var btn = el;
    if (btn && btn.closest) {
      btn = btn.closest('.wishlist_button') || btn;
    }
    setButtonState(btn, nowActive);

    document.querySelectorAll('[data-wishlist-handle="' + handle + '"]').forEach(function (node) {
      setButtonState(node, nowActive);
    });

    updateWishlistCount();

    if (document.querySelector('.js-wishlistBlock')) {
      renderWishlistPage();
    }
  };

  function initButtons() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (node) {
      setButtonState(node, isWishlisted(node.getAttribute('data-wishlist-handle')));
    });
  }

  var HEART_SVG =
    '<svg width="18px" height="18px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path class="heart-outline" d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>' +
      '<path class="heart-solid" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
    '</svg>';

  function productCardHtml(product, handle) {
    var image = (product.featured_image) || (product.images && product.images[0]) || '';
    var price = (product.price / 100).toFixed(2);
    var title = product.title || '';
    return (
      '<div class="c-product" data-wishlist-card="' + handle + '">' +
        '<a href="/products/' + handle + '">' +
          (image ? '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '<h3 class="c-product__title">' + title + '</h3>' +
          '<div class="c-product__price">$' + price + '</div>' +
        '</a>' +
        '<span class="c-product__remove product-listing__wishlist wishlist_button is-active" data-wishlist-handle="' + handle + '" onclick="toggleWishlist(\'' + handle + '\', this)" role="button" tabindex="0" aria-label="Remove from wishlist">' +
          '<span class="wishlist_icon">' + HEART_SVG + '</span>' +
        '</span>' +
      '</div>'
    );
  }

  function renderWishlistPage() {
    var container = document.querySelector('.js-wishlistBlock');
    if (!container) return;
    var handles = getWishlist();

    if (!handles.length) {
      container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. Browse our products and tap the heart icon to save your favorites here.</p>';
      return;
    }

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (product) {
          return product ? { handle: handle, product: product } : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (results) {
      var valid = results.filter(Boolean);
      if (!valid.length) {
        container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. Browse our products and tap the heart icon to save your favorites here.</p>';
        return;
      }
      container.innerHTML = valid
        .map(function (r) {
          return productCardHtml(r.product, r.handle);
        })
        .join('');
    });
  }

  // Exposed so wishlist-account-sync.js can trigger a re-render after merging
  // in server-side (account) wishlist data.
  window.renderWishlistPage = renderWishlistPage;

  function init() {
    initButtons();
    updateWishlistCount();
    if (document.querySelector('.js-wishlistBlock')) {
      renderWishlistPage();
    }
  }

  init();
  document.addEventListener('DOMContentLoaded', init);
})();
